import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../services/api';

const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        try {
            await forgotPassword(email);
            setSubmitted(true);
        } catch (err: any) {
            console.error('Reset failed:', err);
            setError(err.response?.data?.detail || 'Failed to send reset email.');
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-left">
                <div className="auth-form-container">
                    <h1>Forgot Password</h1>
                    <p className="auth-subtitle">Enter your email to reset your password.</p>

                    {error && <div className="error-message" style={{ color: 'red', marginBottom: '1rem' }}>{error}</div>}

                    {!submitted ? (
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="email">Email Address</label>
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your email"
                                    required
                                />
                            </div>

                            <button type="submit" className="btn-primary btn-block">
                                Reset Password
                            </button>

                            <div className="auth-links">
                                <Link to="/login">Back to Login</Link>
                            </div>
                        </form>
                    ) : (
                        <div className="success-message">
                            <p>If an account exists for {email}, you will receive password reset instructions shortly.</p>
                            <Link to="/login" className="btn-primary btn-block">Back to Login</Link>
                        </div>
                    )}
                </div>
            </div>
            <div className="auth-right">
                <div className="auth-branding">
                    <div className="logo-container white">
                        <img src="/logo.svg" alt="Social Mind" className="logo-icon" />
                        <div className="logo-text">
                            <h2>Social Mind</h2>
                            <span>By Iterate.ai</span>
                        </div>
                    </div>
                    <div className="auth-hero-text">
                        <h2>Welcome to Social Mind where social management meets effortless engagement.</h2>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
